import {Button} from "antd";
import React from "react";
import CustomDateTimePicker from "../date/CustomDateTimePicker";
import './searchParam.scss';

const SearchParams = ({searchParam, handleSetSearchParam, handleSearch}) => {
    return (
        <div className='search-params'>
            <div className='search-params-time'>
                <CustomDateTimePicker
                    rows={searchParam}
                    handleSetRows={handleSetSearchParam}
                    isUnixTime={searchParam.isUnix}
                    hasTime={false}
                    hasAdd={false}
                />
            </div>
            <Button
                onClick={handleSearch}
                className="search-params-button"
            >
                Search
            </Button>
        </div>
    )
}

export default SearchParams;